import { createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { sendAsync } from "../../app/applicationSlice"
import { RootThunkApi } from "../../app/store"
import { OssParams } from "../../models/ossparams"
import * as FileService from "../../services/file"

export const getFileUploadToken = createAsyncThunk<
  OssParams,
  string | undefined,
  RootThunkApi
>("file/getFileUploadToken", async (bucketName, api) => {
  return sendAsync(FileService.getFileUploadToken(bucketName), api).then(
    JSON.parse
  )
})

export const uploadFileCloud = createAsyncThunk<
  string,
  OssParams & { file: File; key: string },
  RootThunkApi
>("file/uploadFileCloud", async (params) => {
  const form = new FormData()
  const key = `${params.dir}/${params.key}`
  form.append("key", key)
  form.append("OSSAccessKeyId", params.accessid)

  form.append("policy", params.policy)
  form.append("Signature", params.signature)
  form.append("Expires", params.expire)
  form.append("Content-Disposition", `inline; filename="${params.file.name}"`)
  form.append("file", params.file)
  await axios({
    url: params.host,
    method: "POST",
    data: form,
  })
  return key
})
